module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/check-circle.22f35ba7.svg";